import { render } from "./index.vue?vue&type=template&id=a6d77538&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a6d77538&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d77538"]])

export default __exports__